import { apiRequest } from '@/shared/api/client';
import { ENDPOINTS } from '@/shared/api/endpoints';
import { fromEventoDto, type Event } from '../model/types';

type EventoApiDto = Parameters<typeof fromEventoDto>[0];

const pickActive = (list: EventoApiDto[]): EventoApiDto | null => {
  if (list.length === 0) return null;
  const active = list.find((e) => e.ativo);
  if (active) return active;
  const sorted = [...list].sort(
    (a, b) => new Date(a.dataInicio).getTime() - new Date(b.dataInicio).getTime(),
  );
  return sorted[0] ?? null;
};

export const eventApi = {
  getActive: async (): Promise<{ event: Event | null }> => {
    const list = await apiRequest<EventoApiDto[]>({ method: 'GET', url: ENDPOINTS.EVENTS.LIST });
    const active = pickActive(list);
    return { event: active ? fromEventoDto(active) : null };
  },
  list: async (): Promise<{ events: Event[] }> => {
    const list = await apiRequest<EventoApiDto[]>({ method: 'GET', url: ENDPOINTS.EVENTS.LIST });
    return { events: list.map(fromEventoDto) };
  },
};
